(function () {
  function init(root) {
    if (!root || root.dataset.procurementReady === 'true') return;

    var store = window.SenbederQuoteStore;
    if (!store) return;

    root.dataset.procurementReady = 'true';
    var list = root.querySelector('[data-procurement-items]');
    var empty = root.querySelector('[data-procurement-empty]');
    var clearButton = root.querySelector('[data-procurement-clear]');
    var status = root.querySelector('[data-procurement-inbox-status]');
    var quoteForm = root.querySelector('[data-procurement-quote-form]');
    var quoteBody = root.querySelector('[data-procurement-quote-body]');
    var firstName = root.querySelector('[data-procurement-first-name]');
    var email = root.querySelector('[data-procurement-email]');
    var phone = root.querySelector('[data-procurement-phone]');
    var formError = root.querySelector('[data-procurement-form-error]');
    var formStatus = root.querySelector('[data-procurement-form-status]');
    var inboxOverlay = root.querySelector('[data-procurement-inbox-overlay]');
    var inboxPanel = root.querySelector('[data-procurement-inbox-panel]');
    var inboxThread = root.querySelector('[data-procurement-inbox-thread]');
    var inboxSummary = root.querySelector('[data-procurement-inbox-summary]');
    var inboxProductCount = root.querySelector('[data-inbox-product-count]');
    var inboxUnitCount = root.querySelector('[data-inbox-unit-count]');
    var inboxTotal = root.querySelector('[data-inbox-total]');
    var inboxLastFocused = null;
    var renderController = new AbortController();
    var signal = renderController.signal;
    root.senbederProcurementController = renderController;

    function money(value) {
      return '$' + (Math.max(0, Number(value) || 0)).toFixed(2);
    }

    function icon(name) {
      return '<span aria-hidden="true">' + (name === 'minus' ? '-' : '+') + '</span>';
    }

    function setText(selector, value) {
      root.querySelectorAll(selector).forEach(function (node) { node.textContent = String(value); });
    }

    function render() {
      var items = store.getItems();
      var units = items.reduce(function (sum, item) { return sum + item.qty; }, 0);

      list.innerHTML = '';
      items.forEach(function (item) {
        var row = document.createElement('article');
        row.className = 'sp-item';
        row.dataset.procurementId = item.id;

        var image = document.createElement('img');
        image.className = 'sp-item-image';
        image.src = item.image || '';
        image.alt = item.title || 'Product';
        image.loading = 'lazy';
        if (!item.image) image.hidden = true;

        var copy = document.createElement('div');
        copy.className = 'sp-item-copy';
        var title = document.createElement('a');
        title.className = 'sp-item-title';
        title.href = item.url || '#';
        title.textContent = item.title;
        var meta = document.createElement('div');
        meta.className = 'sp-item-meta';
        var sku = document.createElement('span');
        sku.textContent = item.xbd ? 'SKU ' + item.xbd : 'SKU not provided';
        var desc = document.createElement('span');
        desc.textContent = item.desc || 'Product details available on the product page';
        meta.append(sku, desc);
        var price = document.createElement('div');
        price.className = 'sp-item-price';
        price.textContent = 'Unit price ' + money(item.price);
        copy.append(title, meta, price);

        var controls = document.createElement('div');
        controls.className = 'sp-item-controls';
        var qtyControl = document.createElement('div');
        qtyControl.className = 'sp-qty-control';
        var decrement = document.createElement('button');
        decrement.type = 'button';
        decrement.dataset.procurementAction = 'decrement';
        decrement.setAttribute('aria-label', 'Decrease quantity for ' + item.title);
        decrement.innerHTML = icon('minus');
        var quantity = document.createElement('input');
        quantity.type = 'number';
        quantity.min = '1';
        quantity.step = '1';
        quantity.value = String(item.qty);
        quantity.dataset.procurementAction = 'quantity';
        quantity.setAttribute('aria-label', 'Quantity for ' + item.title);
        var increment = document.createElement('button');
        increment.type = 'button';
        increment.dataset.procurementAction = 'increment';
        increment.setAttribute('aria-label', 'Increase quantity for ' + item.title);
        increment.innerHTML = icon('plus');
        qtyControl.append(decrement, quantity, increment);
        var subtotal = document.createElement('strong');
        subtotal.className = 'sp-item-subtotal';
        subtotal.textContent = money(item.qty * item.price);
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'sp-remove';
        remove.dataset.procurementAction = 'remove';
        remove.textContent = 'Remove';
        controls.append(qtyControl, subtotal, remove);

        row.append(image, copy, controls);
        list.appendChild(row);
      });

      list.hidden = items.length === 0;
      empty.hidden = items.length > 0;
      clearButton.hidden = items.length === 0;
      setText('[data-procurement-product-count]', items.length);
      setText('[data-procurement-unit-count]', units);
      setText('[data-procurement-total]', money(store.total()));
      setText('[data-procurement-state]', items.length ? 'Ready to send' : 'Awaiting products');
      if (formError && items.length) formError.hidden = true;
    }

    function quoteRequestBody() {
      var items = store.getItems();
      var lines = [
        'SENBEDER PROCUREMENT QUOTE REQUEST',
        '',
        'First name: ' + (firstName && firstName.value.trim() ? firstName.value.trim() : 'Not provided'),
        'Email: ' + (email && email.value.trim() ? email.value.trim() : 'Not provided'),
        'WhatsApp / Phone: ' + (phone && phone.value.trim() ? phone.value.trim() : 'Not provided'),
        '',
        'SELECTED PRODUCTS'
      ];

      items.forEach(function (item, index) {
        var quantity = Math.max(1, Math.floor(Number(item.qty) || 1));
        var unitPrice = money(item.price);
        lines.push(
          (index + 1) + '. ' + (item.title || 'Product') +
          ' | SKU: ' + (item.xbd || 'Not provided') +
          ' | Qty: ' + quantity +
          ' | Unit price: ' + unitPrice +
          ' | Subtotal: ' + money(quantity * (Number(item.price) || 0)) +
          (item.url ? ' | Product URL: ' + item.url : '')
        );
      });

      lines.push('', 'ESTIMATED TOTAL: ' + money(store.total()));
      return lines.join('\n');
    }

    function changeQuantity(row, direction) {
      var id = row.dataset.procurementId;
      var item = store.getItems().find(function (entry) { return entry.id === id; });
      if (!item) return;
      var input = row.querySelector('[data-procurement-action="quantity"]');
      var current = Math.max(1, Math.floor(Number(input && input.value) || item.qty));
      var next = direction === 'increment' ? current + 1 : Math.max(1, current - 1);
      store.setQty(id, next, 'procurement-page');
    }

    function openInbox() {
      if (inboxOverlay && inboxPanel) {
        inboxLastFocused = document.activeElement;
        inboxOverlay.hidden = false;
        requestAnimationFrame(function () { inboxOverlay.classList.remove('is-closing'); });
        document.documentElement.classList.add('sp-inbox-open');
        var closeButton = inboxPanel.querySelector('[data-close-procurement-inbox]');
        if (closeButton) closeButton.focus();
        renderInboxSummary();
        return;
      }

      openNativeInbox();
    }

    function closeInbox() {
      if (!inboxOverlay) return;
      inboxOverlay.classList.add('is-closing');
      document.documentElement.classList.remove('sp-inbox-open');
      window.setTimeout(function () {
        if (!inboxOverlay) return;
        inboxOverlay.hidden = true;
        inboxOverlay.classList.remove('is-closing');
        if (inboxLastFocused && typeof inboxLastFocused.focus === 'function') inboxLastFocused.focus();
      }, 190);
    }

    function renderInboxSummary() {
      if (!inboxSummary) return;
      var items = store.getItems();
      var units = items.reduce(function (sum, item) { return sum + item.qty; }, 0);
      inboxSummary.hidden = items.length === 0;
      if (inboxProductCount) inboxProductCount.textContent = String(items.length);
      if (inboxUnitCount) inboxUnitCount.textContent = String(units);
      if (inboxTotal) inboxTotal.textContent = money(store.total());
    }

    function appendInboxMessage(text, variant) {
      if (!inboxThread) return;
      var message = document.createElement('div');
      message.className = 'sp-inbox-message sp-inbox-message--' + variant;
      message.textContent = text;
      inboxThread.appendChild(message);
      inboxThread.scrollTop = inboxThread.scrollHeight;
    }

    function handleInboxIntent(button) {
      var intent = button.dataset.inboxIntent || '';
      var responses = {
        quote: 'I can help prepare a quote. Add products to your procurement list, then review the selected SKUs, quantities, MOQ and estimated total before sending.',
        fitment: 'Please send the motorcycle brand, model, model year, engine size and the part you need. A product link or photo helps us check fitment faster.',
        oem: 'For OEM or B2B projects, share the target model, annual quantity, product category, logo or packaging needs, and destination market.',
        order: 'Please send your order number, sales channel and the email or WhatsApp number used for the order. We will route the request to the sales team.'
      };
      appendInboxMessage(button.textContent.trim(), 'visitor');
      appendInboxMessage(responses[intent] || responses.quote, 'agent');
      if (intent === 'quote') renderInboxSummary();
    }

    function openNativeInbox() {
      var opened = false;
      var candidates = [
        window.Shopify && window.Shopify.chat && window.Shopify.chat.open,
        window.Shopify && window.Shopify.Inbox && window.Shopify.Inbox.open,
        window.ShopifyChat && window.ShopifyChat.open,
        window.ShopifyInbox && window.ShopifyInbox.open
      ];

      candidates.some(function (open) {
        if (typeof open !== 'function') return false;
        try {
          open.call(window.Shopify && window.Shopify.chat ? window.Shopify.chat : window);
          opened = true;
          return true;
        } catch (error) {
          return false;
        }
      });

      if (!opened) {
        var launcher = document.querySelector('[data-shopify-chat-toggle], [data-shopify-inbox-toggle], button[aria-label*="chat" i], button[title*="chat" i]');
        if (launcher) {
          launcher.click();
          opened = true;
        }
      }

      if (!opened) {
        var fallback = root.dataset.inboxUrl || root.dataset.contactUrl || '/pages/contact';
        if (status) status.textContent = 'Inbox is not active. Opening Contact Us.';
        window.location.href = fallback;
      } else if (status) {
        status.textContent = 'Inbox opened.';
      }
    }

    root.addEventListener('click', function (event) {
      var action = event.target.closest('[data-procurement-action]');
      if (action) {
        var row = action.closest('[data-procurement-id]');
        if (!row) return;
        if (action.dataset.procurementAction === 'remove') store.remove(row.dataset.procurementId, 'procurement-page');
        if (action.dataset.procurementAction === 'increment' || action.dataset.procurementAction === 'decrement') changeQuantity(row, action.dataset.procurementAction);
        return;
      }

      if (event.target.closest('[data-procurement-clear]')) {
        store.clear('procurement-page');
        return;
      }

      if (event.target.closest('[data-procurement-open-inbox]')) openInbox();
      if (event.target.closest('[data-close-procurement-inbox]') || event.target === inboxOverlay) closeInbox();
      if (event.target.closest('[data-inbox-open-procurement]')) {
        closeInbox();
        window.setTimeout(function () {
          var target = root.querySelector('[data-procurement-items]');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 210);
      }
      var intentButton = event.target.closest('[data-inbox-intent]');
      if (intentButton) handleInboxIntent(intentButton);
      if (event.target.closest('[data-inbox-open-live-chat]')) openNativeInbox();
    }, { signal: signal });

    root.addEventListener('keydown', function (event) {
      if (!inboxOverlay || inboxOverlay.hidden) return;
      if (event.key === 'Escape') {
        closeInbox();
        return;
      }
      if (event.key !== 'Tab' || !inboxPanel) return;
      var focusable = Array.prototype.slice.call(inboxPanel.querySelectorAll('a[href], button:not([disabled])'));
      if (!focusable.length) return;
      var firstFocusable = focusable[0];
      var lastFocusable = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    }, { signal: signal });

    root.addEventListener('change', function (event) {
      var input = event.target.closest('[data-procurement-action="quantity"]');
      if (!input) return;
      var row = input.closest('[data-procurement-id]');
      if (row) store.setQty(row.dataset.procurementId, input.value, 'procurement-page');
    }, { signal: signal });

    if (quoteForm) {
      quoteForm.addEventListener('submit', function (event) {
        var items = store.getItems();
        if (!items.length) {
          event.preventDefault();
          if (formError) formError.hidden = false;
          if (formStatus) {
            formStatus.textContent = '';
            formStatus.classList.remove('is-success', 'is-error');
          }
          return;
        }

        if (quoteBody) quoteBody.value = quoteRequestBody();
        if (formError) formError.hidden = true;
      }, { signal: signal });
    }

    window.addEventListener(store.changeEvent, render, { signal: signal });
    window.addEventListener(store.changeEvent, renderInboxSummary, { signal: signal });
    render();
    renderInboxSummary();
  }

  function initAll() {
    document.querySelectorAll('[data-procurement-page]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-procurement-page]');
    if (!root) return;
    if (root.senbederProcurementController) root.senbederProcurementController.abort();
    root.dataset.procurementReady = 'false';
  });
})();
